<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12>
                            <h1>Перевод полисов в статус "Оформлен"</h1>
                        </v-flex>
                        <v-flex xs9>
                            <v-text-field
                                    v-model="policy.uuid"
                                    :rules="[rules.required, rules.uuid]"
                                    label="UUID полиса"
                                    validation-on-blur
                                    :loading="loading"
                                    required
                                    class="pt-1"
                            />
                        </v-flex>
                        <v-flex xs3>
                            <v-checkbox
                                    v-model="policy.force"
                                    label="Принудительный перевод"
                                    class="pt-1"
                            />
                        </v-flex>
                        <template v-if="showAdditional">
                            <v-flex xs6>
                                <v-text-field
                                        v-model="dbPolicy.productName"
                                        label="Тип полиса"
                                        validation-on-blur
                                        readonly
                                        class="pt-1"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                        v-model="policy.insurer"
                                        label="Страхователь"
                                        validation-on-blur
                                        readonly
                                        class="pt-1"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <div v-if="processings.length > 0">
                                    <v-select
                                            @change="setOfferDetails"
                                            v-model="policy.offerId"
                                            label="Страховое предложение"
                                            validation-on-blur
                                            :items="processings"
                                            item-text="offer"
                                            item-value="id"
                                            class="pt-1"
                                    />
                                </div>
                            </v-flex>
                            <v-flex xs4>
                                <v-select
                                        v-model="policy.company"
                                        @change="setCompany"
                                        label="Компания"
                                        validation-on-blur
                                        :readonly="!!policy.offerId"
                                        :items="companies"
                                        item-text="name"
                                        item-value="alias"
                                        class="pt-1"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                        v-model="policy.premium"
                                        label="Стоимость"
                                        validation-on-blur
                                        type="text"
                                        class="pt-1"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                        v-model="policy.commission"
                                        label="Комиссия"
                                        validation-on-blur
                                        type="text"
                                        class="pt-1"
                                />
                            </v-flex>
                        </template>
                        <v-flex xs12>
                            <v-btn @click="confirmPolicy" :disabled="!policy.offerId && btnDisable" color="primary">
                                Оформить
                            </v-btn>
                            <v-btn @click="cancelPolicy" :disabled="!dbPolicy.uuid" color="warning">
                                Аннулировать
                            </v-btn>
                            <v-btn @click="loadPolicy" :disabled="!dbPolicy.uuid" color="info">
                                Загрузить ПФ
                            </v-btn>
                            <v-btn @click="downloadPolicy" :disabled="!dbPolicy.uuid" color="info">
                                Скачать ПФ
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import PNotify from 'pnotify/dist/es/PNotify';

export default {
    name: 'PolicyConfirm',
    data: () => ({
        policy: {
            uuid: null,
            product: null,
            company: {name: null, alias: null},
            offerId: null,
            premium: null,
            commission: null,
            insurer: null,
            force: false,
        },
        companies: [],
        processings: [],
        dbPolicy: {
            dbCompany: {name: null, alias: null},
            insurer_name: null,
            success_processing: {premium: null},
        },
        btnDisable: true,
        showAdditional: false,
        loading: false,
        rules: {
            required: v => !!v || 'Обязательное поле',
            uuid: v => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(v) || 'Неверный формат UUID',
        },
    }),
    watch: {
        'policy.uuid': {
            handler() {
                this.debouncedGetPolicyType()
            },
        },
        policy: {
            handler() {
                if (this.policy.company && this.policy.premium && this.policy.commission) {
                    this.btnDisable = false;
                }
            },
            deep: true,
        },
    },
    created() {
        this.debouncedGetPolicyType = _.debounce(this.getPolicy, 500);
    },
    methods: {
        confirmPolicy() {
            axios.post('/policy-confirm', this.policy)
                    .then(response => PNotify.success(response.data.message))
                    .catch(this.handleError);
        },
        cancelPolicy() {
            axios.get(`/policy-confirm/cancel/${this.policy.uuid}`)
                    .then(response => PNotify.success(response.data.message))
                    .catch(this.handleError);
        },
        loadPolicy() {
            axios.get(`/policy-confirm/load/${this.policy.uuid}`)
                    .then(response => PNotify.success(response.data.message))
                    .catch(this.handleError);
        },
        downloadPolicy() {
            window.open(`/order/${this.policy.uuid}/download`, '_blank');
        },
        handleError(error) {
            let message;
            if (error.response && error.response.data) {
                message = (error.response.data.trace && error.response.data.trace.pop()) || error.response.data.message;
            }
            if (!message) {
                message = error.message;
            }
            PNotify.error(message);
        },
        setOfferDetails() {
            let processing = this.processings.find(processing => processing.id === this.policy.offerId);
            console.log(processing)
            if (processing) {
                this.policy.premium = processing.premium;
                this.policy.commission = processing.commission;
                this.policy.company = processing.company;
            }
        },
        getPolicy() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                axios.get(`/policy-confirm/get/${this.policy.uuid}`)
                        .then(response => {
                            if (response.data.message) {
                                PNotify.success(response.data.message);
                                return;
                            }
                            this.dbPolicy = response.data.order;
                            this.processings = response.data.processings || [];
                            this.setPolicyDetails();
                            this.showAdditional = true;
                            this.getCompanies();
                        })
                        .catch(this.handleError)
                        .finally(() => {
                            this.loading = false;
                        });
            }
        },
        getCompanies() {
            if (this.dbPolicy.product) {
                axios.get(`/policy-confirm/companies/${this.dbPolicy.product}`)
                        .then(response => {
                            this.companies = response.data;
                            if (this.dbPolicy.dbCompany) {
                                this.policy.company = {...this.dbPolicy.dbCompany};
                            }
                        });
            }
        },
        setPolicyDetails() {
            this.dbPolicy.productName = this.getProductName(this.dbPolicy.product);
            this.policy.product = this.dbPolicy.product || null;
            this.policy.insurer = this.dbPolicy.insurer_name || null;
            if (this.dbPolicy.dbCompany) {
                this.policy.company = {...this.dbPolicy.dbCompany};
            }
            this.policy.premium = (this.dbPolicy.success_processing && this.dbPolicy.success_processing.premium) || null;
        },
        getProductName(product) {
            switch (product) {
                case 'OSAGO_NEW':
                    return 'ОСАГО';
                case 'MORTGAGE':
                    return 'Ипотека';
                case 'OSAGO_PROLONG':
                    return 'Пролонгация';
                default:
                    return '';
            }
        },
        setCompany() {
            this.policy.company.alias = this.policy.company.alias || this.policy.company;
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/PolicyConfirm.vue